import { useEffect } from 'react';

/**
 * Runs `effect` once on mount. Mirroring `useEffect`, a function returned from `effect`
 * is run as cleanup on unmount; any other value (including the `Promise` from an async
 * `effect`) is ignored.
 */
export const useOnMount = (effect: () => void | Promise<unknown> | (() => void)) => {
  useEffect(() => {
    const result = effect();
    return typeof result === 'function' ? result : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
